export enum Section {
  ALL = 'all',

  LAND = 'land',
  PARCELS = 'parcels',
  ESTATES = 'estates',
  WEARABLES = 'wearables',

  WEARABLES_TRENDING = 'wearables_trending',
  WEARABLES_HEAD = 'wearables_head',
  WEARABLES_EYEBROWS = 'wearables_eyebrows',
  WEARABLES_EYES = 'wearables_eyes',
  WEARABLES_FACIAL_HAIR = 'wearables_facial_hair',
  WEARABLES_HAIR = 'wearables_hair',
  WEARABLES_MOUTH = 'wearables_mouth',

  WEARABLES_UPPER_BODY = 'wearables_upper_body',
  WEARABLES_LOWER_BODY = 'wearables_lower_body',
  WEARABLES_FEET = 'wearables_feet',

  WEARABLES_ACCESSORIES = 'wearables_accessories',
  WEARABLES_EARRING = 'wearables_earring',
  WEARABLES_EYEWEAR = 'wearables_eyewear',
  WEARABLES_HAT = 'wearables_hat',
  WEARABLES_HELMET = 'wearables_helmet',
  WEARABLES_MASK = 'wearables_mask',
  WEARABLES_TIARA = 'wearables_tiara',
  WEARABLES_TOP_HEAD = 'wearables_top_head',

  WEARABLES_SKIN = 'wearables_skin',

  EMOTES = 'emotes',
  EMOTES_DANCE = 'emotes_dance',
  EMOTES_STUNT = 'emotes_stunt',
  EMOTES_GREETINGS = 'emotes_greetings',
  EMOTES_FUN = 'emotes_fun',
  EMOTES_POSES = 'emotes_poses',
  EMOTES_REACTIONS = 'emotes_reactions',
  EMOTES_HORROR = 'emotes_horror',
  EMOTES_MISCELLANEOUS = 'emotes_miscellaneous',

  ENS = 'ens',

  COLLECTIONS = 'collections',
  ON_SALE = 'on_sale',
  ON_RENT = 'on_rent',
  RECENTLY_SOLD = 'recently_sold',
  SALES = 'sales',
  BIDS = 'bids',
  STORE_SETTINGS = 'store_settings'
}
